import { map, flowRight, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

import {
  BUTTON_BOLD,
  BUTTON_ITALIC,
  BUTTON_TITLE,
  BUTTON_SUBTITLE,
  BUTTON_NUMBERING,
  BUTTON_BULLETS,
  BUTTON_BLOCKQUOTE,
  BUTTON_CODE_BLOCK,
  BUTTON_LINK,
  BUTTON_ALIGN_TEXT_DROPDOWN,
} from './constants/buttons';
import { openModal } from '../../actions/open-modal';
import { VerticalSeparator } from '../separator';
import TextEditorButtonGroup from './text-editor-button-group';
import TextEditorToolbar from './text-editor-toolbar';
import { EXPERIMENT_CODE_BLOCK } from '../../constants/experiments';
import withExperiment from '../../hoc/with-experiment';
import styles from './text-editor-inline-toolbar.scss';

const TextEditorInlineToolbar = ({ position, identifier, isCodeButtonVisible, theme }) => {
  const buttons = map(getGroups(isCodeButtonVisible), ({ buttons, buttonClassName }) =>
    renderGroup(buttons, identifier, buttonClassName, get(theme, 'button'))
  );
  const containerClassName = classNames(styles.container, 'text-editor-inline-toolbar');

  return (
    <div className={containerClassName} style={position} onMouseDown={handleMouseDown}>
      <TextEditorToolbar theme={theme}>{buttons}</TextEditorToolbar>
    </div>
  );
};

function handleMouseDown(event) {
  event.preventDefault();
}

function renderGroup(buttons, identifier, buttonClassName, theme) {
  return [
    <TextEditorButtonGroup
      key="group"
      buttons={buttons}
      containerClassName={styles.group}
      buttonClassName={classNames(styles.button, buttonClassName)}
      theme={theme}
      identifier={identifier}
    />,
    <VerticalSeparator key="separator" className={styles.separator}/>,
  ];
}

function getGroups(isCodeButtonVisible) {
  return [
    {
      buttons: [BUTTON_BOLD, BUTTON_ITALIC, BUTTON_TITLE, BUTTON_SUBTITLE],
    },
    {
      buttons: isCodeButtonVisible ?
        [BUTTON_ALIGN_TEXT_DROPDOWN, BUTTON_NUMBERING, BUTTON_BULLETS, BUTTON_BLOCKQUOTE, BUTTON_CODE_BLOCK] :
        [BUTTON_ALIGN_TEXT_DROPDOWN, BUTTON_NUMBERING, BUTTON_BULLETS, BUTTON_BLOCKQUOTE],
      buttonClassName: styles.largeSpacings,
    },
    {
      buttons: [BUTTON_LINK],
    },
  ];
}

TextEditorInlineToolbar.propTypes = {
  position: PropTypes.object,
  identifier: PropTypes.string.isRequired,
  isCodeButtonVisible: PropTypes.bool,
  theme: PropTypes.object,
};

const mapDispatchToProps = {
  openModal,
};

export default flowRight(
  connect(undefined, mapDispatchToProps),
  withExperiment({ isCodeButtonVisible: EXPERIMENT_CODE_BLOCK })
)(TextEditorInlineToolbar);



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-inline-toolbar.js